import styled from "@emotion/styled"
import { colors } from "../../../library/constants/styles/colors"
import PlainLink from "../../ui/link"
import { isLast } from "../../../library/utils/arrays"
import FileItem from "../../formComponents/fileLoader/fileItem"

const Container = styled.table``

const Row = styled.tr`
  vertical-align: top;
`

const Label = styled.td`
  max-width: 180px;
  min-width: 110px;

  padding-bottom: ${(props) => (!props.isLast ? "15px" : 0)};
  color: ${colors.black54};
`

const Value = styled.td`
  padding-bottom: ${(props) => (!props.isLast ? "15px" : 0)};
  padding-left: 30px;
`

const InfoTable = ({ data = [] }) => {
  const composeValue = (record) => {
    if (record.text) return record.text

    if (record.textList) return ""

    if (record.link) {
      const link = record.link
      return (
        <PlainLink
          native={record.link.external || false}
          to={link.to}
          newTab={link.newTab || false}
        >
          {link.text}
        </PlainLink>
      )
    }

    if (record.links) {
      return record.links.map((link, i) => {
        const url = typeof link === "string" ? link : link.url
        return (
          <PlainLink
            native={record.external || false}
            to={url}
            newTab={record.newTab || false}
            style={{ marginBottom: !isLast(record.links, i) ? 5 : 0 }}
            key={url + i}
          >
            {record.linkTitleKey ? link[record.linkTitleKey] : url}
          </PlainLink>
        )
      })
    }

    if (record.files) {
      return record.files.map((file, i) => (
        <FileItem
          name={file.name}
          size={file.size}
          url={file.url}
          key={file.id}
          containerProps={{
            style: { marginBottom: !isLast(record.files, i) ? 5 : 0 },
          }}
        />
      ))
    }

    if (record.component) return record.component

    return "—"
  }

  const records = data?.filter(Boolean)

  return data.length ? (
    <Container>
      <tbody>
        {records.map((record, i) => {
          return (
            <Row key={record.label}>
              <Label isLast={isLast(records, i)}>{record.label}:</Label>
              <Value isLast={isLast(records, i)}>{composeValue(record)}</Value>
            </Row>
          )
        })}
      </tbody>
    </Container>
  ) : null
}

export default InfoTable
